export default __webpack_public_path__ + "static/media/Sarah Rosalie.07ac2b37.png";